import React, { forwardRef } from 'react';

const Archived = forwardRef( ( props, ref ) => (
	<svg
		ref={ ref }
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 32"
		{ ...props }
	>
		<path d="M3.9 10.6V28c0 .6.4 1 1 1h22.2c.6 0 1-.4 1-1V10.6zM20 17h-8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1zM30 8.6V3.9c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v4.7z" />
	</svg>
) );

Archived.displayName = 'Archived';

export default Archived;
